import { ShieldOff } from 'lucide-react'

type Props = {
  onUnblock?: () => void
}

export function BlockedUserBanner({ onUnblock }: Props) {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6 text-center">
      <div className="h-14 w-14 rounded-full bg-muted flex items-center justify-center mb-3">
        <ShieldOff className="h-7 w-7 text-muted-foreground" />
      </div>
      <p className="text-sm text-muted-foreground mb-3">
        You blocked this user. Unblock to send messages.
      </p>
      {onUnblock && (
        <button
          onClick={onUnblock}
          className="text-sm font-medium text-primary hover:underline"
        >
          Unblock
        </button>
      )}
    </div>
  )
}
